import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
  {
    id: 'beheerders-instellingen',
    title: 'Beheerder instellingen',
    classes: {
      wrapper: 'menu-item--return',
    },
    type: 'basic',
    icon: 'mat_outline:admin_panel_settings',
    link: '/beheerders-instellingen/modules',
  },
];

export const adminNavigation: FuseNavigationItem[] = [
  {
    id: 'modules',
    title: 'Modules',
    type: 'basic',
    link: '/beheerders-instellingen/modules',
    // icon: 'mat_outline:power',
  },
  {
    id: 'pages',
    title: "Pagina's",
    type: 'basic',
    link: '/beheerders-instellingen/paginas',
    // icon: 'mat_outline:article',
  },
  {
    id: 'gebruikersrollen',
    title: 'Gebruikersrollen',
    type: 'basic',
    link: '/beheerders-instellingen/gebruikersrollen',
    // icon: 'mat_outline:supervised_user_circle',
  },
  // {
  //   id: 'gebruikers',
  //   title: 'Gebruikers',
  //   type: 'basic',
  //   link: '/beheerders-instellingen/gebruikers',
  //   icon: 'mat_outline:manage_accounts',
  // },
  {
    id: 'templates',
    title: 'Templates',
    type: 'basic',
    link: '/beheerders-instellingen/templates',
    // icon: 'mat_outline:post_add',
  },
  {
    id: 'formulieren',
    title: 'Aanmaakformulieren',
    type: 'basic',
    link: '/beheerders-instellingen/formulieren',
  },
  {
    id: 'widgets',
    title: 'Widgets',
    type: 'basic',
    link: '/beheerders-instellingen/widgets',
  },
  {
    id: 'action-flows',
    title: 'Automatiseringsflows',
    type: 'basic',
    link: '/beheerders-instellingen/automatiseringsflows',
  },
  {
    id: 'settings',
    title: 'Instellingen',
    type: 'basic',
    link: '/beheerders-instellingen/instellingen',
    // icon: 'feather:settings',
  },
  {
    id: 'dashboard',
    title: 'Terug naar dashboard',
    classes: {
      wrapper: 'menu-item--return',
    },
    type: 'basic',
    icon: 'heroicons_outline:arrow-left',
    link: '/dashboard',
  },
];
